import React, { useState } from "react";
import { ChevronDown, HelpCircle } from "lucide-react";
import useSEO from "@/hooks/useSEO";

const FAQS = [
  { q: "Will it actually look like MY dog?", a: "Yes. Our AI uses your photo as a direct reference. The better the photo, the better the match. Clear, well-lit face shots work best." },
  { q: "What do I get?", a: "The Digital Legend Pack includes a custom HD sports card, mobile wallpaper, social-media-ready image, and a print-ready file (3000x4200px) — all delivered instantly with no watermark." },
  { q: "How long does it take?", a: "About 15 seconds for the preview. Instantly downloadable after payment." },
  { q: "Can I get a refund?", a: "We offer one free regeneration if you're not happy. Refunds available within 24 hours if the card doesn't resemble your dog." },
  { q: "What sports are available?", a: "Football, basketball, baseball, hockey, and soccer." },
  { q: "Can I put my cat on a card?", a: "Absolutely. Any pet works." },
  { q: "Are real team logos used?", a: "No. All team branding is original and fictional \u2014 your dog plays for a totally unique team." },
  { q: "How are my photos used?", a: "Your photo is used only to generate your card and is deleted from our servers within 24 hours. We never share or sell your images." },
];

function FAQItem({ q, a }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="border border-[var(--color-border)] rounded-[12px] bg-[var(--color-white)] overflow-hidden">
      <button onClick={() => setOpen(!open)} className="w-full flex items-center justify-between px-6 py-5 text-left" data-testid={`faq-item-${q.slice(0,15).replace(/\s/g,'-').toLowerCase()}`}>
        <span className="font-body font-medium text-[var(--color-text-dark)] pr-4">{q}</span>
        <ChevronDown size={18} className={`text-[var(--color-text-light)] shrink-0 transition-transform duration-200 ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="px-6 pb-5 animate-fade-in">
          <p className="font-body text-sm text-[var(--color-text-mid)] leading-relaxed">{a}</p>
        </div>
      )}
    </div>
  );
}

export default function FAQPage() {
  useSEO({ title: "FAQ", description: "Frequently asked questions about CardMyDog — photo tips, pricing, refunds, sports, and how your photos are used.", path: "/faq" });
  return (
    <div className="min-h-screen py-16 md:py-24" data-testid="faq-page">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <div className="w-12 h-12 rounded-full mx-auto mb-4 flex items-center justify-center" style={{ backgroundColor: "rgba(245,166,35,0.1)" }}>
            <HelpCircle size={24} style={{ color: "var(--color-gold)" }} />
          </div>
          <h1 className="font-heading text-4xl sm:text-5xl uppercase tracking-tight text-[var(--color-text-dark)] mb-3">
            Frequently Asked Questions
          </h1>
          <p className="font-body text-[var(--color-text-mid)]">Everything you need to know about Card My Dog</p>
        </div>
        <div className="space-y-3">
          {FAQS.map((faq) => <FAQItem key={faq.q} q={faq.q} a={faq.a} />)}
        </div>
      </div>
    </div>
  );
}
